// extracted by mini-css-extract-plugin
export default {"container":"App-module_container_w8XR2I","main":"App-module_main_CjyF50","content":"App-module_content_oTD3O5"};